module.exports = __webpack_public_path__ + "img/sAztecGolT_193x205.11e814a7.png";